import type { ReactNode } from 'react'
import { ChatSplitLayout } from '@/components/chat/chat-split-layout.organism'
import { useChatView } from './chat.view.hook'
import { ChatContentView } from './chat-content.view'

export const ChatView = (): ReactNode => {
  const { state, handlers, titleEditState, splitView, participantActions, websocketState } =
    useChatView()

  return (
    <ChatSplitLayout
      isSplitViewOpen={splitView.isOpen}
      contentType={splitView.contentType}
      contentData={splitView.contentData}
      onCloseSplitView={handlers.handleCloseSplitView}
    >
      <ChatContentView
        state={state}
        handlers={handlers}
        titleEditState={titleEditState}
        participantActions={participantActions}
        websocketState={websocketState}
      />
    </ChatSplitLayout>
  )
}
